<template>
    <div>
        <vx-card title="PAGAMENTOS" class="mb-base overflow-hidden border border-dashed d-theme-border-grey-light">
            <div v-for="(payment, index) in payments" :key="index" :class="{'mt-4': index}">
                <div class="flex justify-between">
                    <div class="flex flex-col">
                        <span class="mb-1 font-bold text-primary">{{ payment.description.toUpperCase() }}</span>
                        <h4>
                            <number
                                ref="totalPaid"
                                :to="payment.percent"
                                :format="(number) => number.toFixed(0)  "
                                :duration="0.6"
                                :delay="0.5"
                                easing="Power1.easeOut"
                            />%
                        </h4>
                    </div>
                    <div class="flex flex-col text-right">
                        <span class="flex -mr-1">
                            <!-- <span class="mr-1">{{ payment.quantity }} </span> -->
                            <!-- <feather-icon :icon=" browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon> -->
                        </span>
                        <h5 class="mt-8">
                            <number
                                ref="totalPaid"
                                :to="payment.value"
                                :format="(number) => $options.filters.currency(number)"
                                :duration="0.6"
                                :delay="0.5"
                                easing="Power1.easeOut"
                            />
                            <!-- {{ payment.value.toFixed(2).replace('.', '.') }} -->
                        </h5>
                    </div>
                </div>
                <vs-progress :percent="payment.percent" ></vs-progress>
            </div>

            <div slot="no-body-bottom" class="flex justify-between text-center">

                <div class="w-1/2 border border-dashed d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-4">TOTAL</p>
                    <p class="mb-4 text-3xl font-semibold">
                        <number
                            ref="totalPaid"
                            :to="totalSum"
                            :format="(number) => $options.filters.currency(number)"
                            :duration="0.6"
                            :delay="0.5"
                            easing="Power1.easeOut"
                        />
                    </p>
                </div>
                <div class="w-1/2 border border-dashed d-theme-border-grey-light border-r-0 border-b-0">
                    <p class="mt-4">PEDIDOS</p>
                    <p class="mb-4 text-3xl font-semibold">
                        <number
                            ref="totalPaid"
                            :to="totalOrders"
                            :duration="0.6"
                            :delay="0.5"
                            easing="Power1.easeOut"
                        />
                    </p>
                </div>

                <!-- <div class="w-full border border-dashed d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mb-4 mt-4 text-3xl font-semibold">
                        <number
                            ref="totalPaid"
                            :to="totalSum"
                            :format="(number) => $options.filters.currency(number)"
                            :duration="0.6"
                            :delay="0.5"
                            easing="Power1.easeOut"
                        />
                    </p>
                </div> -->
            </div>
        </vx-card>
    </div>
</template>

<script>
    export default {
        props : {
            dataPayments : {
                required : true,
                type : Array
            },
            totalOrders : {
                required : true
            }
        },

        data () {
            return {
                totalSum : 0
            }
        },

        computed : {
            payments () {
                let payments = [...this.dataPayments]
                let totalValue = payments.reduce((acumulator, current ) => acumulator + current.value, 0)
                payments.forEach(payment => {
                    this.totalSum += payment.value
                    payment.percent = (payment.value * 100) / totalValue
                })
                return payments.sort((a, b) => a.value - b.value)
            }
        }
    }
</script>